'use client';

/**
 * Gedeelde client-side cache voor /api/site-settings. Header, footer en
 * marketing-tracker riepen dit endpoint elk apart aan (3x per pageview);
 * nu delen ze een module-level promise per sessie.
 */

let cached: Promise<unknown> | null = null;

export function fetchSiteSettings(): Promise<unknown> {
  if (!cached) {
    cached = fetch('/api/site-settings')
      .then((response) => response.json())
      .catch((error) => {
        // Bij een fout niet blijven hangen op een rejected promise.
        cached = null;
        throw error;
      });
  }
  return cached;
}
